import { useFormik } from 'formik';
import { SurveyFilter, SurveyFiltersProps } from './props';

export const useSurveyFilters = (onFilter: SurveyFiltersProps['onFilter']) => {
    const formik = useFormik<SurveyFilter>({
        initialValues: {
            code: '',
            title: '',
            status: '',
            startDate: '',
            endDate: '',
        },
        onSubmit: (values) => {
            onFilter(values);
        },
    });

    return {
        formik,
    };
};
